import { CASES } from './constants';

const getInitialSectionSort = () => {
    const saved = localStorage.getItem('sectionSort');
    return saved ? JSON.parse(saved) : ['id', 'DESC'];
};

const initialState = {
    shared: [],
    filterForm: {
        title: '',
        bodyText: '',
        id: '',
        publicPrivate: '',
    },
    sectionForm: {
        body: '',
        clearanceMemoSectionTypeId: 3,
        divisionId: '',
        productsToAdd: [],
        public: false,
        shareable: false,
        status: '',
        tagIdList: [66, 64],
        title: '',
        unLinkList: [],
    },
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    sectionRange: [0, 19],
    sectionSort:  getInitialSectionSort(),
    defaultFilterRange: [0, 19],
    itemsPerPage: 20,
    isSSModalOpen: false,
    modalMode: '',
    section: {},
    tagOptions: [],
    clearanceMemoTags: [],
    clearanceMemoSectionTypes: [
        { label: '', value: '' },
        { label: 'Header', value: 1 },
        { label: 'Term', value: 2 },
        { label: 'Media', value: 3 },
        { label: 'Territory', value: 4 },
        { label: 'Language', value: 5 },
        { label: 'Licensing', value: 6 },
        { label: 'Restriction', value: 7 },
        { label: 'Editing', value: 8 },
        { label: 'Dubbing', value: 9 },
        { label: 'Subtitling', value: 10 },
        { label: 'Copyright', value: 11 },
        { label: 'Footer', value: 12 },
        { label: 'General', value: 13 },
        { label: 'Film Clips A& Stills', value: 14 },
        { label: 'Legitimate Stage', value: 15 },
        { label: 'Paid Ad Memo', value: 16 },
        { label: 'Remakes, Sequels, and/or Spin Offs', value: 17 },
    ],
    isPublic: true,
};

/**
 * Reducer function to manage the shared sections state in the Redux store.
 *
 * It handles actions related to updating shared sections, filtering shared sections,
 * and clearing shared sections.
 *
 * @param {Object} state - The current state of the shared sections.
 * @param {Object} action - The action dispatched to the reducer.
 * @return {Object} The new state of the shared sections after applying the action.
 **/
export function sharedSections(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_SHARED_SECTIONS: {
            if (payload.sectionSort) {
                localStorage.setItem('sectionSort', JSON.stringify(payload.sectionSort));
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_SHARED_SECTIONS_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_SHARED_SECTIONS: {
            return {
                ...initialState,
                sectionSort: state.sectionSort
            };
        }
        default:
            return state;
    }
}
